import { gql } from '@apollo/client';

export const NEW_AUX_MACHINE_UNIT = gql`
  fragment NewAuxMachineUnit on AuxMachineUnit {
    id
  }
`;
